import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PurchaseOrder } from './orders.model';
import { OrdersService } from './orders.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
    selector: 'app-confirm-reception-dialog',
    templateUrl: './confirm-reception-dialog.component.html',
    standalone: false
})
export class ConfirmReceptionDialogComponent implements OnInit {

    displayedColumns: string[] = ['product', 'ordered', 'received'];

    constructor(
        public dialogRef: MatDialogRef<ConfirmReceptionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public order: PurchaseOrder,
        private orderService: OrdersService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit(): void {
    }

    confirm(): void {
        this.orderService.confirmReception(this.order.id, this.order)
            .subscribe(() => {
                this.displayInfo('Recepción confirmada con éxito');
                this.dialogRef.close(true);
            });
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

    public displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10000;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }
}